import { Button, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import * as Yup from "yup";
import { useSnack } from "../../../services/SnakbarProvider";
import { handleError } from "../../../services/errorHandler";
import { resetPassword } from "../../../api/auth";
import { useState } from "react";

function ResetPasswordForm({ email, token }) {
  const { openSnack } = useSnack();
  const navigate = useNavigate();

  const [error, setError] = useState("");

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .required("La contraseña es requerida"),
  });

  const formik = useFormik({
    initialValues: { newPassword: "" },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!email || !token) {
        setError("Faltan parámetros de recuperación de contraseña.");
        return;
      }
      try {
        await resetPassword({ email, token, newPassword: values.newPassword });
        openSnack("Contraseña actualizada exitosamente", "success");
        navigate("/login");
      } catch (e) {
        openSnack(handleError(e), "error");
      }
    },
  });

  if (!email || !token) {
    return (
      <Typography color="error">
        Faltan parámetros de recuperación de contraseña. Por favor revisa el enlace enviado a tu correo.
      </Typography>
    );
  }

  return (
    <>
      <Typography component="h1" variant="h5">
        Restablecer Contraseña
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <Box component="form" sx={{ mt: 1 }} onSubmit={formik.handleSubmit}>
        <TextField
          margin="normal"
          required
          fullWidth
          name="newPassword"
          label="Nueva Contraseña"
          type="password"
          id="newPassword"
          value={formik.values.newPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
          helperText={formik.touched.newPassword && formik.errors.newPassword}
          autoComplete="new-password"
          autoFocus
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Actualizar Contraseña
        </Button>
      </Box>
    </>
  );
}

export default ResetPasswordForm; 